<template>
	<div class="newsDetails-Mobile">
    <div class="hand">
      <el-breadcrumb :separator-icon="ArrowRight">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>全球资讯</el-breadcrumb-item>
        <el-breadcrumb-item v-if="dataInfo.categName" :to="{ path: '/newsList',query:{id:dataInfo.articleClassPid} }">{{dataInfo.categName.split("-")[0]}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="dataInfo.categName" :to="{ path: '/newsList',query:{id:dataInfo.articleClassPid,selectArticleId:dataInfo.articleClassId} }">{{dataInfo.categName.split("-")[1]}}</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb> 
    </div> 
    <div class="main">
      <div class="news-details" v-if="dataInfo.id">
        <div class="title">{{dataInfo.title}}</div>
        <div class="flex">
          <div class="other">
            <div><text class="iconfont">&#xe629;</text><span>{{dataInfo.publishDate}}</span></div>
            <!-- <div><text class="iconfont">&#xe625;</text><span>{{dataInfo.categName}}</span></div> -->
            <!-- <div><text class="iconfont">&#xe628;</text><span>{{dataInfo.pv}}</span></div> -->
          </div>
          <div class="source">来源：{{dataInfo.source}}</div>
        </div>
        <div class="content">
          <div v-html="dataInfo.articleDetails"></div>
        </div>
        <div class="attachments-list" v-if="dataInfo.attachmentsUrl">
          <ul>
            <li v-for="(item,index) in dataInfo.attachmentsUrl" :key="index">
              <a :href="commenUrl+item.url" target="_blank">{{item.name}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {reactive,ref, getCurrentInstance, onMounted, watch,nextTick} from "vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { useRouter,useRoute } from 'vue-router';
const route=useRoute();
const router=useRouter();
const {proxy}= getCurrentInstance();
const id=ref(route.query.id);
const dataInfo=ref({});
function getDetails(){
  proxy.$request({
    url:"N_INDUSTRYARTICLEMAGE_FINDINFO",
    data:{
      "id":id.value
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      dataInfo.value=res.data.result;
      if(dataInfo.value.publishDate)dataInfo.value.publishDate=dataInfo.value.publishDate.split(" ")[0]
      if(dataInfo.value.attachmentsUrl)dataInfo.value.attachmentsUrl=JSON.parse(dataInfo.value.attachmentsUrl)
      processMediaContent();
    }
  }).catch((err)=>{
    console.log(err)
  })
}
getDetails();
watch(()=>route.query.id,(newValue,oldValue)=>{
  if(route.query.id){
    id.value=route.query.id;
    getDetails();
  }
});
const pageInfo=reactive({
  pageNo:1,
  pageSize:8,
  count:0,
});
function jumper(id){
  router.push({path:'newsDetails1',query:{id:id}})
}
// 处理富文本内容中的图片、视频和段落样式
const processMediaContent = () => {
  nextTick(() => {
    const container = document.querySelector('.content');
    if (container) {
      const maxWidth = container.clientWidth * 0.8;
      
      // 处理普通图片
      const images = container.querySelectorAll('img:not([attr-src])');
      images.forEach(img => {
        img.style.maxWidth = `${maxWidth}px`;
        img.style.height = 'auto';
        img.style.display = 'block';
        img.style.margin = '10px auto';
      });
      
      // 特别处理带有attr-src属性的视频链接
      const videoImgTags = container.querySelectorAll('img[attr-src]');
      videoImgTags.forEach(img => {
        const videoUrl = img.getAttribute('attr-src');
        // 检查是否为视频文件
        if (videoUrl && (videoUrl.endsWith('.mp4') || videoUrl.endsWith('.mov') || videoUrl.endsWith('.avi'))) {
          // 创建视频元素替换图片元素
          const videoElement = document.createElement('video');
          videoElement.controls = true;
          videoElement.preload = 'metadata';
          videoElement.style.maxWidth = `${maxWidth}px`;
          videoElement.style.height = 'auto';
          videoElement.style.display = 'block';
          videoElement.style.margin = '10px auto';
          
          const sourceElement = document.createElement('source');
          sourceElement.src = videoUrl;
          sourceElement.type = 'video/mp4';
          
          videoElement.appendChild(sourceElement);
          
          // 添加不支持视频的提示
          const fallbackText = document.createElement('p');
          fallbackText.textContent = '抱歉，您的浏览器不支持 HTML5 视频播放。';
          videoElement.appendChild(fallbackText);
          
          // 替换元素
          img.parentNode.replaceChild(videoElement, img);
        } else {
          // 不是视频的话，仍然按普通图片处理
          img.style.maxWidth = `${maxWidth}px`;
          img.style.height = 'auto';
          img.style.display = 'block';
          img.style.margin = '10px auto';
        }
      });
      
      // 确保所有视频元素也被正确调整大小
      const videos = container.querySelectorAll('video');
      videos.forEach(video => {
        video.style.maxWidth = `${maxWidth}px`;
        video.style.height = 'auto';
        video.style.display = 'block';
        video.style.margin = '10px auto';
      });
      
      // 处理段落样式
      const paragraphs = container.querySelectorAll('p');
      paragraphs.forEach(p => {
        // 应用样式到所有段落
        p.style.margin = '10px 0';
        p.style.lineHeight = '1.6';
        p.style.wordWrap = 'break-word';
        p.style.color = '#333333';
        p.style.fontSize = '14px';
        p.style.textIndent = '2em';
      });
    }
  });
};

// 组件挂载后处理媒体内容
onMounted(() => {
  // 窗口大小改变时重新调整媒体大小
  window.addEventListener('resize', processMediaContent);
});
</script>

<style lang="less" scoped>
.newsDetails-Mobile{
  width: 100vw;
  min-height: 100vh;
  background: #F7F7F7 ;
  padding-top:44px;
  /* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
  @font-face {
    font-family: 'iconfont';  /* Project id 5014541 */
    src: url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.woff2?t=1757471216125') format('woff2'),
        url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.woff?t=1757471216125') format('woff'),
        url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.ttf?t=1757471216125') format('truetype');
  }
  .iconfont{
    font-family: 'iconfont';  /* Project id 5014541 */
  }
  .flex{
    display: flex;
  }
  .ellipsis-multiline{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 显示的行数，可以根据需要修改 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hand{
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #E6E6E6;
    .el-breadcrumb{
      padding: 15px;
      .el-breadcrumb__inner{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
    }
  }
  .main{
    .news-details{
      flex:1;
      background: #fff;
      padding: 20px;
      border-radius: 10px;
      min-height: 600px;
      .title{
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 3.47vw;
        color: #252525;
        line-height: 5.33vw;
        text-align: center;
        margin-bottom: 3.733vw;
      }
      .other{
        display: flex;
        margin-bottom: 1.87vw;
        text{
          margin-right: 5px;
          font-weight: 400;
          font-size: 3.27vw;
          color: #A4A8B4;
          line-height: 4.533vw;
        }
        span{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 3.2vw;
          color: #A4A8B4;
          line-height: 4.533vw;
        }
      }
      .source{
        flex: 1;
        text-align: right;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 3.2vw;
        line-height: 4.533vw;
      }
      .content{
        div{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #5D5E61;
          line-height: 28px;
          img{
            max-width: 100%;
          }
          span{
            white-space:break-spaces !important;
            word-break: break-all;
          }
        }
      }
      .attachments-list{
        padding-top: 20px;
        padding-bottom: 20px;
        ul li{
          a{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #5D5E61;
            line-height: 28px;
          }
        }
      }
    }
    .news-list{
      width: 310px;
      margin-left: 20px;
      .tit{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #222222;
        line-height: 22px;
        margin-bottom: 15px;
      }
      ul{
        padding: 0 20px;
        background: #fff;
        border-radius: 10px;
        li{
          padding: 20px 0;
          border-bottom: 1px solid #EFEFEF;
          cursor: pointer;
          .n-title{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #222222;
            line-height: 24px;
            margin-bottom: 10px;
          }
          .n-abstract{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #A4A8B4;
            line-height: 24px;
            margin-bottom: 10px;
          }
          .n-time{
            text{
              margin-right: 5px;
            }
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #A4A8B4;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>